import React, {useEffect, useState} from 'react';
import TemplateDefault from "../../../components/template-default";
import Button from "../../../components/button";
import InputForm from "../../../components/input-form";
import Card from "../../../components/card";
import {useQuery} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import {useNavigate, useParams} from "react-router-dom";
import TechnicianService from "../../../services/technician-service";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const MySwal = withReactContent(Swal);

const TechnicianForm = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({name: ""});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    useQuery({
        queryFn: () => TechnicianService.getById(id).then((data) => {
            setState(data);

            return data;
        }),
        queryKey: ['technician', {id}],
        enabled: !!id,
    });

    const submit = (newEdit) => {
        setIsLoading(true);

        const formData = new FormData();
        Object.keys(state).forEach(key => {
            formData.append(key, state[key]);
        });

        if (!!id) formData.append('_method', 'PUT');

        const response = !!id ? TechnicianService.edit(formData, id) : TechnicianService.create(formData);

        response
            .then(({data}) => {
                toast.success("Salvo com sucesso.");
                if (newEdit === "save_and_edit") {
                    navigate(`/technician/form/${data.id}`);
                } else {
                    setState({ name: "" });
                    navigate(`/technician/form`);
                }
            })
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            })
            .finally(() => setIsLoading(false));
    }

    const deleteResale = () => {
        MySwal.fire({
            icon: "warning",
            title: "Excluir!",
            showCancelButton: true,
            text: "Tem certeza que deseja excluir o técnico?",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            confirmButtonColor: '#e64942',
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                setIsLoading(true);
                TechnicianService.delete(id)
                    .then(() => {
                        navigate("/technician");
                    })
                    .catch((err) => {
                        const {data: {message}} = err.response;
                        toast.error(AlertMessage[message] ?? "Não foi possível excluir");
                    })
                    .finally(() => setIsLoading(false));
        }
        });
    }

    const handleInput = ({target: {value, id}}) => setState(prev => ({...prev, [id]: value}));

    return (
        <TemplateDefault title={"Cadastro de técnico" + (id ? ` #${id}` : "")} isLoading={isLoading}>
            <Card title="Dados">
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">

                    <InputForm id="name" name="name" value={state.name} onChange={handleInput} label="Nome *" col="col-span-12"/>

                </div>
            </Card>

            <Card wrapperClass="mt-5">
                <div className="flex justify-end gap-3">
                    <Button onClick={() => submit('save_and_new')} type="submit" target="primary">
                        Salvar e adicionar novo
                    </Button>
                    {
                        id &&
                        <Button onClick={deleteResale} target="danger">
                            Excluir
                        </Button>
                    }
                    <Button onClick={() => navigate("/technician")} target="warning">
                        Cancelar
                    </Button>
                    <Button onClick={() => submit('save_and_edit')} target="success">
                        Salvar
                    </Button>
                </div>
            </Card>
        </TemplateDefault>
    );
}

export default TechnicianForm;